export const ACTION_TYPES = {
  SOCKET_SEND: 'SOCKET_SEND',
  REGISTER_COMPONENT_LEVEL_SOCKET_LISTENER: 'REGISTER_COMPONENT_LEVEL_SOCKET_LISTENER',
  UNREGISTER_COMPONENT_LEVEL_SOCKET_LISTENER: 'UNREGISTER_COMPONENT_LEVEL_SOCKET_LISTENER',
  SOCKET_CONNECTED: 'SOCKET_CONNECTED',
  SOCKET_DISCONNECTED: 'SOCKET_DISCONNECTED'
}
